import MultipleSelect from 'components/commons/multiple-select'
import { InlineError } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'

export const ProductHighlight = ({ salePageDetail, onSearchProduct, optionsProduct, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'Product Highlight'}
            content={
                <div className={'flex flex-col w-1/2 space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>Pilih Product</div>
                    <MultipleSelect
                        name={'products'}
                        placeholder={'Search Product...'}
                        onSearch={onSearchProduct}
                        value={salePageDetail?.products}
                        options={optionsProduct}
                        onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                    />
                    <InlineError className='mt-2' message={errorForm?.products} />
                </div>
            }
        />
    )
}
